import React, { useState } from 'react';
import EmojiPicker from 'emoji-picker-react';
import IconButtonWithTooltip from 'components/buttons/IconButtonWithTooltip';
import { faCrosshairs } from '@fortawesome/free-solid-svg-icons';

function EmoticonPicker({ value, onEmojiClick }) {
    const [pickerOpen, setPickerOpen] = useState(false);

    const handleEmojiClick = (emojiData) => {
        setPickerOpen(false);
        onEmojiClick(emojiData.emoji);
    };

    const togglePicker = () => {
        setPickerOpen((prev) => !prev);
    };

    return (
        <div style={{ position: 'relative', display: 'inline-block' }}>
            {value && <span style={{ fontSize: '1.5rem', marginRight: '0.5rem' }}>{value}</span>}
            <IconButtonWithTooltip
                translationId="emoticonPicker.pick"
                icon={faCrosshairs}
                onClick={togglePicker}
                type="Button"
                size="xs"
            />
            {pickerOpen && (
                <div style={{ position: 'absolute', zIndex: 10, top: '100%', left: 0 }}>
                    <EmojiPicker onEmojiClick={handleEmojiClick} />
                </div>
            )}
        </div>
    );
}

export default EmoticonPicker;
